import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, User } from 'lucide-react';

const ChatHeader = ({ partnerId, partnerProfile, online, partnerTyping }) => {
  const navigate = useNavigate();
  const isOnline = online.has(partnerId);

  let statusEl;
  if (partnerTyping) {
    statusEl = <span className="text-fnl-pink italic">typing...</span>;
  } else if (isOnline) {
    statusEl = 'Online now';
  } else {
    statusEl = 'View profile';
  }

  return (
    <div className="px-5 py-3 border-b border-purple-900/40 flex items-center gap-3">
      <button
        onClick={() => navigate('/chat')}
        className="md:hidden text-white"
        aria-label="Back"
      >
        <ArrowLeft className="w-5 h-5" />
      </button>
      <Link to={`/profile/${partnerId}`} className="flex items-center gap-3" data-testid="chat-partner-header">
        <div className="w-10 h-10 rounded-full bg-fnl-pink/30 overflow-hidden flex items-center justify-center relative">
          {partnerProfile?.photo_base64 ? (
            <img src={partnerProfile.photo_base64} alt="" className="w-full h-full object-cover" />
          ) : <User className="w-5 h-5 text-fnl-pink" />}
          {isOnline && (
            <span className="absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full bg-green-400 border-2 border-fnl-purple shadow-[0_0_6px_rgba(74,222,128,0.9)]" />
          )}
        </div>
        <div>
          <div className="text-white font-semibold leading-tight">{partnerProfile?.name || '...'}</div>
          <div className="text-xs text-purple-300" data-testid="chat-partner-status">
            {statusEl}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ChatHeader;
